import { OccasionPageLayout } from '@/components/seo/OccasionPageLayout';
import { getOccasion } from '@/data/occasions';
export default function AnniversaryAppreciation() {
  const o = getOccasion('anniversary-appreciation')!;
  return <OccasionPageLayout occasion={o} />;
}
